<template>
  <div class="mx-2">
    <v-row>
      <v-col cols="6">
        <v-row>
          <v-col class="pt-0 mt-0">
            <v-card shrink>
              <v-toolbar flat color="grey lighten-3">
                <v-toolbar-title>{{ $t('campaigns.label.emailNotifications') }}</v-toolbar-title>
              </v-toolbar>
              <CampaignEmailNotifications
                :users="users"
                :editionMode="editionMode" 
                :emailNotifications="campaign.emailNotifications"
                jsonpath="$.emailNotifications"
                @change="onChange"
              ></CampaignEmailNotifications>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 mt-0">
            <v-card shrink>
              <v-toolbar flat color="grey lighten-3">
                <v-toolbar-title>{{ $t('campaigns.label.userGroups') }}</v-toolbar-title>
              </v-toolbar>
              <CampaignUserGroups
                :users="users"
                :editionMode="editionMode" 
                :userGroups="campaign.userGroups"
                jsonpath="$.userGroups"
                @change="onChange"
              ></CampaignUserGroups>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pt-0 mt-0">
            <v-card shrink>
              <v-toolbar flat color="grey lighten-3">
                <v-toolbar-title>{{ $t('campaigns.label.sessionModes') }}</v-toolbar-title>
              </v-toolbar>
              <CampaignSessionModes
                :users="users"
                :editionMode="editionMode" 
                :sessionModes="campaign.sessionModes"
                jsonpath="$.sessionModes"
                @change="onChange"
              ></CampaignSessionModes>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-card shrink>
          <v-toolbar flat color="grey lighten-3">
            <v-toolbar-title>{{ $t('campaigns.label.sessions') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <TooltipIconButton
              v-if="!editionMode" 
              icon="mdi-rhombus-split"
              id="split_corpus"
              :tooltip="$t('campaigns.label.splitCorpus')"
              @click="confirmOverwriteSplit = true"
            ></TooltipIconButton>
          </v-toolbar>
          <CampaignSessions
            :editionMode="editionMode" 
            :sessions="campaign.sessions"
            :availableReconciliationUsers="availableReconciliationUsers"
            jsonpath="$.sessions"
            @change="onChange"
            @action="onAction"
          ></CampaignSessions>
        </v-card>
      </v-col>
    </v-row>
    <DeleteConfirmDialog
      v-if="confirmOverwriteSplit"
      idHint="split"
      :title="$t('campaigns.overwriteSplitConfirm.title')"
      :html="$t('campaigns.overwriteSplitConfirm.message')"
      @yes="splitCorpus(theLabel)"
      @no="confirmOverwriteSplit = false"
    ></DeleteConfirmDialog>

  </div>
</template>

<script>
import CampaignUserGroups from "./CampaignUserGroups";
import CampaignEmailNotifications from "./CampaignEmailNotifications";
import CampaignSessions from "./CampaignSessions";
import CampaignSessionModes from "./CampaignSessionModes";
import DeleteConfirmDialog from "../utils/DeleteConfirmDialog.vue"
import TooltipIconButton from "../utils/TooltipIconButton.vue"

export default {
  props: [ "users", "campaign", "editionMode", "availableReconciliationUsers" ],
  components: {
    CampaignUserGroups,
    CampaignSessions,
    CampaignSessionModes,
    CampaignEmailNotifications,
    DeleteConfirmDialog,
    TooltipIconButton,
  },
  data() {
    return {
      confirmOverwriteSplit: false,
    }
  },
  methods: {
    onChange(event) {
      this.$emit("change", event)
    },
    onAction(event) {
      this.$emit("action", event)
    },
    splitCorpus() {
      if (this.confirmOverwriteSplit == true) {
        this.confirmOverwriteSplit = false;
        this.$store._splitCampaignCorpus(this.campaign.id);
      }
    }
  }
}
</script>